export function removeSubstring(originalString: string, substringToRemove: string): string {
    return originalString.replace(new RegExp(substringToRemove, 'g'), '');
}

export function truncate(str: string, length = 15): string {
    if (str.length <= length) return str;
    return str.slice(0, length).trimEnd() + ' ...';
}
